import {DataTableSortStatus} from 'mantine-datatable';
import {TestRun} from '../types';

// ⚠️ THE COMPARATOR DOES NOT LIVE HERE (FNP-912 / FNP-923).
//
// Nulls-last, numeric-vs-string and empty-string-as-missing are published once in
// `@flexinet/ui-components`:
//
//     import {useTableSort} from '@flexinet/ui-components';
//
// What remains is the one genuinely per-entity decision: WHICH key this table
// sorts by.

// DEFAULT: most recent wake first, keyed on `startedAt`.
//
// `startedAt` is NonNull on TestRun (`startedAt: AWSDateTime!`), which makes it a
// safer default than the `created` used by testing-test-definitions — there is no
// nulls-degrade-to-insertion-order risk here at all.
//
// It is NOT `completedAt`: that is NULL for every RUNNING run, so sorting by it
// would push the in-flight runs — the ones an operator watching a wake most wants
// to see — to the bottom of the table. It is not `updated` either: the abandon
// sweep touches that, so the list would reorder itself underneath a reader.
export const DEFAULT_SORT: DataTableSortStatus<TestRun> = {
    columnAccessor: 'startedAt',
    direction: 'desc',
};
